(ns ycweb.util.hash
  #?(:cljs
     (:require
       [goog.crypt :as gcrypt]
       [goog.crypt.Md5 :as Md5]
       [goog.crypt.Sha256 :as Sha256]
       [goog.crypt.base64 :as base64])
     :clj
     (:require
       [digest :as dig]
       [clojure.data.codec.base64 :as base64])))

;; TODO: Gosh, this needs :clj implementation :/

(defn string->bytes [s]
  #?(:cljs
     (gcrypt/stringToUtf8ByteArray s)))                     ;; must be utf8 byte array


(defn bytes->hex
  "convert bytes to hex"
  [bytes-in]
  #?(:cljs
     (gcrypt/byteArrayToHex bytes-in)))

(defn hash-bytes [digester bytes-in]
  #?(:cljs
     (do
       (.update digester bytes-in)
       (.digest digester))))


(defn md5-
  "convert bytes to md5 bytes"
  [bytes-in]
  #?(:cljs
     (hash-bytes (goog.crypt.Md5.) bytes-in)))

(defn md5-bytes
  "convert utf8 string to md5 byte array"
  [string]
  #?(:cljs
     (md5- (string->bytes string))))

(defn md5 
  "convert utf8 string to md5 hex string"
  [string] 
  #?(:cljs
     (bytes->hex (md5-bytes string))
     :clj
     (dig/digest "MD5" string)))

(defn sha256-
  "convert bytes to sha256 bytes"
  [bytes-in]
  #?(:cljs
     (hash-bytes (goog.crypt.Sha256.) bytes-in)))

(defn sha256-bytes
  "convert utf8 string to sha256 byte array"
  [string]
  #?(:cljs
     (sha256- (string->bytes string))))

(defn sha256 [string]
  "convert utf8 string to sha256 hex string"
  #?(:cljs
     (bytes->hex (sha256-bytes string))
     :clj
     (dig/digest "SHA-256" string)))

(defn base64-encode [string]
  #?(:cljs
     (base64/encodeString string)
     :clj
     (String. ^bytes (base64/encode (.getBytes string)))))



(defn base64-decode [string]
  #?(:cljs
     (->
       string
       (base64/decodeStringToByteArray true)
       gcrypt/utf8ByteArrayToString)

     :clj
     (String. ^bytes (base64/decode (.getBytes string)))))


